<div class="px-sm-1 container-fluid">

  <div class="d-flex flex-row justify-content-between" style="min-width: 20em;">
    <div class="px-sm-1 font-italic h5">
      Measurements
    </div>
    <div *ngIf="!isEditing && scoutPath && !scoutPath.scoutPoints.length">
      <button class="m-sm-1 btn btn-sm btn-secondary" (click)="edit()" title="Edit Scout Points"><i class="fa fa-edit"></i>&nbsp; Edit</button>
    </div>
    <div *ngIf="isEditing" class="d-flex flex-row small">
      <button [disabled]="!bIsModified || !bIsValid" class="m-sm-1 btn btn-sm btn-secondary" (click)="save()"><i class="fa fa-save"></i>&nbsp;Save</button>
      <button class="m-sm-1 btn btn-sm btn-secondary" (click)="cancel()">&nbsp;Cancel</button>
    </div>
  </div>
    
    <div *ngIf="!scoutPath?.scoutPoints?.length; else haveValidScoutPath;" >
      <div *ngIf="scoutPath" class="alert alert-info" >No points defined in this path.</div>
    </div>    
    <ng-template #haveValidScoutPath>
      <table class="scout-point-table table table-condensed p-0 m-0">
        <tr *ngFor="let scoutPoint of scoutPath.scoutPoints; index as pointIndex;" class="p-sm-1">
          <ng-container [ngTemplateOutlet]="scoutPointTemplate"
            [ngTemplateOutletContext]="{ scoutPoint: scoutPoint, pointIndex: pointIndex }">
          </ng-container>
        </tr>
      </table>
    </ng-template>

    <ng-template #scoutPointTemplate let-scoutPoint="scoutPoint" let-pointIndex="pointIndex">
      <td class="pb-sm-1 p-0" id="scout-point-editor-{{pointIndex}}">
        <div class="p-0 m-0 container-fluid" [ngClass]="{ 'origin-scout-point': !scoutPoint.parentId && scoutPoint.type=='HA', 'selected-point': selectedPoint?.id==scoutPoint.id}">
            <app-scout-point-editor 
              [scoutPoint]="scoutPoint"
              [scoutPoints]="scoutPath.scoutPoints"
              [buildingPoints]="buildingPoints" 
              [isLoadingBuildingPoints]="isLoadingBuildingPoints" 
              [bearingDefaultAngles]="bearingDefaultAngles"
              [locked]="locked"
              (selected)="setSelectedPoint($event)"
              (changed)="onScoutPointChanged(scoutPoint)"
              (editModeChanged)="onChildEditorEditModeChanged($event)"
              (formStatusChanged)="onScoutPointFormStatusChanged($event)"></app-scout-point-editor>         
        </div>
      </td>
      <td class="m-0 p-0 pl-sm-1" style="vertical-align:top;">
        <div class="d-flex flex-column justify-content-center">
          <button class="ref-btn btn btn-secondary" (click)="createChild(scoutPoint,0)" [ngClass]="locked?'disabled':''"> + </button>
          <div class="btn-group" role="group" aria-label="Scout Point Options">
              <button [disabled]="isEditing||scoutPoint.type=='VIA'" class="ref-btn btn btn-secondary" 
                      (click)="onRefClick(scoutPoint)">Ref</button>
              <div *ngIf="scoutPath.scoutPoints.length > 1" [ngClass]="locked?'disabled':''" class="btn-group p-0 m-0" dropdown>
                <button id="edit-options-btn" title="More..." 
                        style="margin-left:2px;padding:0 2px;" class="ref-btn btn btn-secondary dropdown-toggle" 
                        dropdownToggle aria-controls="dropdown-edit-options">
                </button>
                <ul id="dropdown-edit-options" *dropdownMenu class="p-2 dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="edit-options-btn">                      
                  <li *ngIf="scoutPoint.parentId" role="menuitem"><div (click)="delete(scoutPoint)" role="button" class="m-sm-1"><i class="fa fa-times btn btn-danger"></i>&nbsp;Remove</div></li>
                  <li *ngIf="pointIndex > 0" role="menuitem"><div (click)="moveUp(scoutPoint)" role="button" class="m-sm-1"><i class="fa fa-chevron-up btn btn-secondary"></i>&nbsp;Move Up</div></li>
                  <li *ngIf="pointIndex < scoutPath.scoutPoints.length - 1" role="menuitem"><div (click)="moveDown(scoutPoint)" role="button" class="m-sm-1"><i class="fa fa-chevron-down btn btn-secondary"></i>&nbsp;Move Down</div></li>
                </ul>
              </div>
          </div>
          <button class="ref-btn btn btn-secondary" (click)="createChild(scoutPoint,1)" [ngClass]="locked?'disabled':''"> + </button>
        </div>
      </td>
    </ng-template>

</div>